export default "__VITE_ASSET__D5d8IvYE__"